<template>
  <b-col lg="12">
    <b-col>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          :to="{ name: 'pedidos-vendas-padrao-create' }"
      >
        <feather-icon icon="PlusIcon" size="18"/>
        Novo
      </b-button>
    </b-col>
    <b-col md="12" class="mt-2">
      <b-row class="mb-3">
        <filtros @search="search" ref="filtros"/>
      </b-row>
    </b-col>
    <b-col md="12">
      <b-row>
        <pedidos @paginateFilters="paginateFilters"/>
      </b-row>
    </b-col>
  </b-col>
</template>

<script>
import Filtros from '@/views/app/operacoes/pedidosVendas/filtros.vue';
import Pedidos from '@/views/app/operacoes/pedidosVendas/pedidos.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  components: {
    Filtros,
    Pedidos,
  },
  return: {
    filters: {
      dataInicial: '',
      dataFinal: '',
      pageSize: 5,
      page: 1,
    },
  },
  computed: {
    ...mapState('SLS_PedidosVendas', ['filters']),
    ...mapGetters('SLS_PedidosVendas', ['getFilters']),
  },
  methods: {
    ...mapActions('SLS_PedidosVendas', ['setFilters', 'retornaPedidoVendas']),
    async search(newFilters) {
      await this.setFilters(newFilters);
      await this.retornaPedidoVendas();
    },
    async paginateFilters(newFilters) {
      await this.setFilters(newFilters);
      await this.retornaPedidoVendas();
    },
  },
  mounted() {
    if (this.filters) {
      this.$refs.filtros.filtersData = { ...this.filters };
    }
  },
};
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
</style>
